<template>
  <div class="gh-sidebar__body">
    <div v-if="listLoading && !listItems.length" class="gh-sidebar__loading">
      <i class="fa fa-spinner fa-spin" aria-hidden="true"></i>
    </div>
    <div v-else-if="listError" class="gh-sidebar__error">{{ listError }}</div>
    <div v-else-if="!listItems.length" class="gh-sidebar__empty">
      {{ $t('generation_history.sZeroRecords') }}
    </div>
    <div v-else ref="listEl" class="gh-sidebar__list" @scroll="onListScroll">
      <component
        :is="resolveListItemComponent(item.project_type)"
        v-for="item in listItems"
        :key="item.project_id"
        :item="item"
        @view-all="onViewAll"
      />
    </div>
    <div v-if="listLoading && listItems.length" class="gh-sidebar__loading-more">
      <i class="fa fa-spinner fa-spin" aria-hidden="true"></i>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import { getListItemComponent } from '../shared/listItemComponents';

export default {
  name: 'GenerationHistoryListView',
  computed: {
    ...mapState('generationHistory', [
      'listItems',
      'listLoading',
      'listError',
      'listScrollTop',
      'scrollAfterRefresh',
    ]),
  },
  mounted() {
    this.$nextTick(() => {
      this.restoreListScrollPosition();
    });
  },
  watch: {
    'listItems.length'() {
      this.$nextTick(() => {
        if (this.scrollAfterRefresh === 'list-top') {
          this.scrollListToTop();
          return;
        }
        this.restoreListScrollPosition();
      });
    },
    scrollAfterRefresh(value) {
      if (value !== 'list-top') {
        return;
      }
      this.$nextTick(() => {
        this.scrollListToTop();
      });
    },
  },
  methods: {
    ...mapActions('generationHistory', [
      'openDetail',
      'loadMoreList',
      'saveListScrollTop',
      'clearScrollAfterRefresh',
    ]),
    resolveListItemComponent(projectType) {
      return getListItemComponent(projectType);
    },
    onViewAll(projectId) {
      const listEl = this.$refs.listEl;
      if (listEl) {
        this.saveListScrollTop(listEl.scrollTop);
      }
      this.openDetail(projectId);
    },
    restoreListScrollPosition() {
      if (!this.listScrollTop) {
        return;
      }
      const listEl = this.$refs.listEl;
      if (!listEl || listEl.scrollTop === this.listScrollTop) {
        return;
      }
      listEl.scrollTop = this.listScrollTop;
    },
    scrollListToTop() {
      const listEl = this.$refs.listEl;
      if (listEl) {
        listEl.scrollTop = 0;
      }
      this.saveListScrollTop(0);
      this.clearScrollAfterRefresh();
    },
    onListScroll(event) {
      const el = event.target;
      this.saveListScrollTop(el.scrollTop);
      if (el.scrollTop + el.clientHeight >= el.scrollHeight - 80) {
        this.loadMoreList();
      }
    },
  },
};
</script>
